module.exports = __webpack_public_path__ + "img/images_event_banner_575_215.9ff2c7fc.png";